<template>
  <div>
    <v-card flat class="rounded-lg mb-8" outlined style="background: transparent;">
      <v-row class="text-center pa-4">
        <v-col cols="12">
          <template v-if="uploadProgress === null">
            <p class="body-1 mb-0">
              {{ $tc('message-upack-upload') }}
            </p>
            <p class="body-1">
              {{ $tc('message-upack-warning') }}
            </p>
            <h2 class="my-4">
              {{ message }}
            </h2>
            <app-drag-and-drop ref="upload" @file="addFile" />
            <v-btn
              block
              id="send_file_button"
              dark
              color="blue"
              @click="update"
              :disabled="!file"
            >
              {{ $tc('upack-button') }}
            </v-btn>
          </template>
          <template v-else>
            <p class="body-1">
              {{ $tc('uploading_file') }}
            </p>
            <v-row no-gutters justify="center">
              <v-progress-linear :value="uploadProgress" />
            </v-row>
            <v-row justify="end" class="mx-0 mb-4 mt-2">
              <v-btn
                id="abort"
                color="green"
                @click="abort"
              >
                {{ $tc('abort_uplaod') }}
              </v-btn>
            </v-row>
          </template>
        </v-col>
      </v-row>
    </v-card>
    <confirm-modal
      id="upload"
      :open="showActivateConfirm"
      :title="$t('activate_upack_title')"
      :message="messageComposed"
      :positive-btn-title="$t('send')"
      @negative="closeActivateConfirm"
      @positive="confirmWithSuccess"
    />
  </div>
</template>

<script>
import ConfirmModal from '@/components/ConfirmModal.vue'
import AppDragAndDrop from '@/components/ui/AppDragAndDrop'

export default {
  data () {
    return {
      file: null,
      message: '',
      showActivateConfirm: false
    }
  },
  components: {
    AppDragAndDrop,
    ConfirmModal
  },
  computed: {
    uploadProgress () {
      return this.$store.state.hsm.upackUploadProgress
    },
    messageComposed: function () {
      if (this.message) {
        return this.$tc('activate_upack_message') + ': ' + this.message
      } else {
        return this.$tc('activate_upack_message') + ': Desconhecido'
      }
    }
  },
  methods: {
    addFile (file) {
      this.file = file
    },
    confirmWithSuccess () {
      this.closeActivateConfirm()
      const self = this
      this.$store
        .dispatch('hsm/updateFirmware', this.file)
        .then(() => {
          this.$notify.success({})
          // this.clearForm()
          this.closeActivateConfirm()
          self.$store.dispatch('warning/load')
        })
        .catch(err => {
          this.clearForm()
          if (err.message === 'Aborted') return
          const errObj = this.$store.getters['error/getErrorObj'](err)
          if (errObj) {
            this.$notify.hsmError(errObj, err)
          } else {
            this.$notify.error({ message: err })
          }
        })
    },
    closeActivateConfirm () {
      this.showActivateConfirm = false
    },
    clearForm () {
      this.closeActivateConfirm()
      this.file = null
      this.$refs.upload.refresh()
      this.message = ''
    },
    abort () {
      this.$store.dispatch('hsm/abortFirmwareUpdate')
        .then(() => {
          this.message = ''
        })
    },
    update () {
      const UPACK_V1 = 1
      const UPACK_VER_LEN = 4
      const UPACK_MAX_DESCR = 256

      const self = this
      const fileReader = new FileReader()
      fileReader.onload = function (event) {
        const arrayBuffer = new Uint8Array(event.target.result)
        const s = Uint32Array.from(arrayBuffer.subarray(0, UPACK_VER_LEN))
        if (s[0] !== UPACK_V1) {
          self.$notify.error({ message: self.$tc('invalid_upack') })
          self.clearForm()
          return false
        }
        //
        const v2 = arrayBuffer.subarray(UPACK_VER_LEN, UPACK_MAX_DESCR)
        let i = v2.indexOf(0x00)
        if (i === -1) {
          i = v2.length
        }
        self.message = String.fromCharCode.apply(null, v2.subarray(0, i))
        self.showActivateConfirm = true
      }
      fileReader.readAsArrayBuffer(this.file)
    }
  }
}
</script>
